import { cn } from 'helpers/classnames';

export const containerClasses = 'relative inline-block';

export const backgroundShadowClasses = 'absolute top-1 w-full h-full border-l-0 rounded-r-full';

export const contentClasses = cn(
  'flex flex-row items-center gap-0.5 border border-l-0 rounded-r-full bg-[#fff] px-3 py-2 text-xs font-semibold',
  'lumon:body-xs-medium lumon:text-gray-800'
);

export const tooltipClasses = 'p-3 text-sm shadow-lg rounded-lg bg-default-minimal text-base';
